import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '../validator/customValidators';
import {MatDialogRef} from '@angular/material/dialog';
import {GusService} from 'src/app/core/services/gus.service';
import {INewCompany} from '../model/interface/new-company.model.interface';

@Component({
  selector: 'app-search-for-company',
  templateUrl: './search-for-company.component.html',
  styleUrls: ['./search-for-company.component.scss'],
})
export class SearchForCompanyComponent implements OnInit {
  findCompany: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<SearchForCompanyComponent>,
    private gusService: GusService
  ) {
  }

  ngOnInit() {
    this.findCompany = this.formBuilder.group(
      {
        nip: [null, CustomValidators.NIPValidator],
        regon: [null, CustomValidators.REGONValidator],
      },
      {
        validators: CustomValidators.atLeastOne(Validators.required, [
          'nip',
          'regon',
        ]),
      }
    );
    this.onChanges();
  }

  onChanges(): void {
    this.findCompany.get('nip').valueChanges.subscribe((nip) => {
      if (nip !== '') {
        this.findCompany.get('regon').setValue('');
      }
    });

    this.findCompany.get('regon').valueChanges.subscribe((regon) => {
      if (regon !== '') {
        this.findCompany.get('nip').setValue('');
      }
    });
  }

  findCompanyInGUS() {
    const nip = this.findCompany.get('nip').value;
    const regon = this.findCompany.get('regon').value;
    if (nip !== '') {
      return this.gusService
        .findByNip(nip)
        .subscribe((company: any) => this.propagateCompanyInfo(company));
    } else {
      return this.gusService
        .findByRegon(regon)
        .subscribe((company: any) => this.propagateCompanyInfo(company));
    }
  }

  private propagateCompanyInfo(company: any) {
    this.dialogRef.close(company);
  }
}
